<template>
  <router-view />
  <AppNotifications />
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAdminAuthStore } from '@/stores/adminAuth'
import { useAdminSocketStore } from '@/stores/adminSocket'
import AppNotifications from '@/components/core/AppNotifications.vue'

const auth = useAdminAuthStore()
const sock = useAdminSocketStore()
const route = useRoute()

function ensureMetaDescription() {
  let el = document.querySelector('meta[name="description"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', 'description')
    document.head.appendChild(el)
  }
  return el
}

watch(
  () => route.fullPath,
  () => {
    const title = String(route.meta?.title || 'Admin')
    const description = String(route.meta?.description || 'Admin Control Plane của bot-trade.')
    document.title = `${title} | Bot-Trade Admin`
    ensureMetaDescription().setAttribute('content', description)
  },
  { immediate: true }
)

onMounted(async () => {
  await auth.restore()
  if (auth.authenticated) sock.connect()
})
</script>
